export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7457.57f4e969.jpg";